export default function IntroSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Your Search for the Perfect Rental Ends Here
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
            At TREX RE LLC, we understand that finding the right place to call home is more than just a transaction—it's about finding a space where you can build your life, create memories, and feel secure. Whether you're looking to rent a house, duplex, or apartment in El Paso, we're here to make your rental journey smooth and stress-free.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-home-smile-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Quality Properties</h3>
            <p className="text-gray-600 leading-relaxed">
              Well-maintained homes in desirable neighborhoods throughout El Paso
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Flexible Options</h3>
            <p className="text-gray-600 leading-relaxed">
              Various credit profiles welcome—we work with you to find solutions
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-customer-service-2-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Responsive Service</h3>
            <p className="text-gray-600 leading-relaxed">
              Dedicated support team ready to assist you every step of the way
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
